export default "/images/MümtazÇopur.jpg?54a2f9fd41c959f9f157ff725aeab999";